import { connect } from "react-redux";
import ActivityComponent from "../components/ActivityComponent";

const mapStateToProps = state => {
  return {
    messages: state.messages.messages
  };
};

export default connect(mapStateToProps)(ActivityComponent);



// WEBPACK FOOTER //
// ./src/containers/ActivityContainter.js